import React, { useState } from 'react';
import './AnimationQuote.css';

function AnimationQuote() {
  const [formData, setFormData] = useState({
    animationType: '2D Animation',
    packageTier: 'Gold ($2,500+)',
    name: '',
    phone: '',
    email: '',
    details: ''
  });
  
  const [status, setStatus] = useState(null);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('sending');

    try {
      const response = await fetch('/api/send-animation-quote', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        setStatus('success');
        setFormData({
          animationType: '2D Animation',
          packageTier: 'Gold ($2,500+)',
          name: '',
          phone: '',
          email: '',
          details: ''
        });
      } else {
        setStatus('error');
      }
    } catch (error) {
      console.error(error);
      setStatus('error');
    }
  };

  return (
    <div className="quote-page">
      <div className="quote-container">
        <h1>Request a Quote</h1>
        <p>Tell us about your animation project and we'll get back to you with a detailed proposal.</p>
        
        <form onSubmit={handleSubmit} className="quote-form">
          <div className="form-row">
            <div className="form-group">
              <label>Animation Type</label>
              <select name="animationType" value={formData.animationType} onChange={handleChange} required>
                <option value="2D Animation">2D Animation</option>
                <option value="3D Animation">3D Animation</option>
                <option value="Commercial Production">Commercial Production</option>
                <option value="Custom Project">Custom Project / Other</option>
              </select>
            </div>
            
            <div className="form-group">
              <label>Package Tier</label>
              <select name="packageTier" value={formData.packageTier} onChange={handleChange} required>
                <option value="Silver">Silver Package</option>
                <option value="Gold">Gold Package</option>
                <option value="Platinum">Platinum Package</option>
                <option value="Custom Quote">Need Custom Quote</option>
              </select>
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label>Your Name</label>
              <input type="text" name="name" value={formData.name} onChange={handleChange} required />
            </div>
            
            <div className="form-group">
              <label>Email Address</label>
              <input type="email" name="email" value={formData.email} onChange={handleChange} required />
            </div>
          </div>

          <div className="form-group">
            <label>Phone Number (Optional)</label>
            <input type="tel" name="phone" value={formData.phone} onChange={handleChange} />
          </div>

          <div className="form-group">
            <label>Project Details (Scope, Length, Reference Videos, etc.)</label>
            <textarea 
              name="details" 
              rows="5" 
              value={formData.details} 
              onChange={handleChange} 
              required
            ></textarea>
          </div>

          <button type="submit" className="btn-submit" disabled={status === 'sending'}>
            {status === 'sending' ? 'Sending Request...' : 'Submit Request'}
          </button>

          {status === 'success' && <p className="success-msg">Your quote request has been sent! We will contact you soon.</p>}
          {status === 'error' && <p className="error-msg">Something went wrong. Please try again later or email us directly.</p>}
        </form>
      </div>
    </div>
  );
}

export default AnimationQuote;
